export default __webpack_public_path__ + "static/assets/bf69c79b1be57be26ec85b6096c46d89.png";